import { Checkbox } from "matsuri-ui";
import { MatsuriFormsSelectQuestionProps } from "matsuri-forms-sdk";

export const SelectQuestion = (props: MatsuriFormsSelectQuestionProps) => {
  return (
    <div
      style={{
        display: "flex",
        gap: 16,
      }}
    >
      {props.options.map((option) => {
        return (
          <Checkbox
            defaultChecked
            type="radio"
            name={props.name}
            value={option.value}
            key={option.value}
          >
            {option.label}
          </Checkbox>
        );
      })}
    </div>
  );
};
